import CustomModal from "../CustomModal";
import { translate } from "../../Services/translation";
import React, { useState } from "react";
import button from "../Button";

export default function NoticeModal({ open, setOpen, onClick, comment }) {

    async function handleOnClick() {
        onClick();

        setOpen(false);
    }

    return (
        <CustomModal isOpen={open} onClose={() => setOpen(false)}
                     title={translate('product.noticemodal.title')}
                     description={comment}
        >
            <div>
                <button
                    className="modal__submit-button"
                    onClick={() => handleOnClick()}>{translate('product.logo.submit')}
                </button>
            </div>
        </CustomModal>
    )
}
